import React from "react";
import { FileSignature } from "lucide-react";

import PDFViewer from "../displayPDF/displayPdf.js";
import Signature from "../signature/signature.js";
import "./contractModalContent.css";

function ContractModalContent({ bookingId, booking, onSignatureSubmit }) {
  const signedAt = booking?.signatureTimestamp
    ? new Date(booking.signatureTimestamp).toLocaleString("en-US", {
        dateStyle: "medium",
        timeStyle: "short",
      })
    : null;

  return (
    <div className="contract-modal-layout">
      <section className="contract-modal-panel contract-modal-preview">
        <div className="contract-modal-panel-header">
          <FileSignature size={18} aria-hidden="true" />
          <span>Contract PDF</span>
        </div>
        <PDFViewer
          bookingId={bookingId}
          versionKey={`${booking?.signatureTimestamp || ""}-${booking?.signature ? "signed" : "unsigned"}`}
          height="100%"
          className="contract-modal-pdf"
        />
      </section>

      <section className="contract-modal-panel contract-modal-signature">
        <div className="contract-modal-panel-header">
          <FileSignature size={18} aria-hidden="true" />
          <span>Signature</span>
        </div>
        {signedAt && (
          <div className="contract-modal-signed-status">
            Signed {signedAt}
          </div>
        )}
        <Signature onSubmit={onSignatureSubmit} />
      </section>
    </div>
  );
}

export default ContractModalContent;
